import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

export default function AuthPage() {
  const { requestOTP, verifyOTP } = useAuth();
  const [step, setStep] = useState('email'); // 'email' or 'otp'
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRequestOTP = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await requestOTP(email);
      setStep('otp');
    } catch (err) {
      setError(err.message || 'Failed to send code. Try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await verifyOTP(email, otp);
      window.location.reload();
    } catch (err) {
      setError(err.message || 'Invalid code. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary to-primary-container flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-surface-container-lowest rounded-xl shadow-xl p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold font-headline text-primary mb-2">EGAC Strategy Hub</h1>
          <p className="text-on-surface-variant">Track Readiness & Club Growth</p>
        </div>

        {/* Form */}
        {step === 'email' ? (
          <form onSubmit={handleRequestOTP} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-2">
                Email address
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                disabled={loading}
                autoFocus
                className="w-full px-4 py-2 rounded-lg border border-outline-variant bg-surface text-on-surface placeholder-on-surface-variant focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full btn-primary disabled:opacity-50"
            >
              {loading ? 'Sending...' : 'Send access code'}
            </button>
            {error && <div className="error-message text-center">{error}</div>}
          </form>
        ) : (
          <form onSubmit={handleVerifyOTP} className="space-y-4">
            <p className="text-sm text-on-surface-variant text-center mb-4">
              Check your email for the 6-digit code.
            </p>
            <div>
              <label htmlFor="otp" className="block text-sm font-medium mb-2">
                Access code
              </label>
              <input
                id="otp"
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                maxLength="6"
                required
                disabled={loading}
                autoFocus
                className="w-full px-4 py-2 rounded-lg border border-outline-variant bg-surface text-on-surface placeholder-on-surface-variant focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50 text-center text-2xl tracking-widest"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full btn-primary disabled:opacity-50"
            >
              {loading ? 'Verifying...' : 'Access hub'}
            </button>
            <button
              type="button"
              onClick={() => {
                setStep('email');
                setOtp('');
                setError('');
              }}
              className="w-full btn-secondary"
            >
              Use different email
            </button>
            {error && <div className="error-message text-center">{error}</div>}
          </form>
        )}

        {/* Footer */}
        <div className="text-center mt-6 pt-6 border-t border-outline-variant">
          <p className="text-xs text-on-surface-variant">Valid for 7 days from login.</p>
        </div>
      </div>
    </div>
  );
}
